import { render, staticRenderFns } from "./MuvekkilVekaletUcretleriList.vue?vue&type=template&id=04cb80ae"
import script from "./MuvekkilVekaletUcretleriList.vue?vue&type=script&lang=ts"
export * from "./MuvekkilVekaletUcretleriList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports